<template>
  <div class="animated fadeIn">
    <b-modal
      ref="modal-template-preview"
      scrollable
      centered
      button-size="md"
      v-on:close="hideModal"
    >
      <template #modal-title><i class="fas fa-file-alt"></i> PREVIEW</template>
      <div class="pb-4">
        <label for="txtDescription"> Preview:</label>
        <div
          style="border: solid 1px #ccc; border-radius: 3px; min-width: 100%;min-height: 543px; max-height: 543px; padding: 7px; overflow: scroll;"
        >
          <div v-html="template"></div>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button
            @click="hideModal"
            type="button"
            class="btn btn-third btn-sm"
            v-b-tooltip.hover
            :title="'Fechar'"
          >
            <i :class="'fas fa-times'"></i
            ><span class="d-md-down-none">&nbsp; Fechar</span>
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import _ from 'lodash'

export default {
  name: 'PreviewTemplateModal',
  mixins: [ActionsForm],
  data () {
    return {
      template: ''
    }
  },
  methods: {
    onLoad () {},
    showModal (template) {
      this.$refs['modal-template-preview'].show()
      if (!_.isNil(template)) this.template = template
    },
    hideModal () {
      this.$refs['modal-template-preview'].hide()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/crm/details/campanha/modal/PreviewTemplateModal.vue